
// File:src/loaders/XHRLoader.js

/**
 * @author mrdoob / http://mrdoob.com/
 */

export class XHRLoader {
	manager: any;
	crossOrigin?: any;
	responseType?: any;

	constructor(manager?: any) {
		this.manager = (manager !== undefined) ? manager : THREE.LoadingManager;
	}

	load(url: any, onLoad: (arg0: any) => void, onProgress?: (arg0: any) => void, onError?: (arg0: any) => void): void {
		const request: XMLHttpRequest = new XMLHttpRequest();
		request.open('GET', url, true);

		request.addEventListener('load', function (this: XMLHttpRequest) {
			if (onLoad) onLoad(this.response);
		}, false);

		if (onProgress !== undefined) {
			request.addEventListener('progress', function (event: ProgressEvent) {
				onProgress(event);
			}, false);
		}

		if (onError !== undefined) {
			request.addEventListener('error', function (event: ProgressEvent) {
				onError(event);
			}, false);
		}

		if (this.crossOrigin !== undefined) (request as any).crossOrigin = this.crossOrigin;
		if (this.responseType !== undefined) request.responseType = this.responseType;

		request.send(null);
	}

	setResponseType(value: any): void {
		this.responseType = value;
	}

	setCrossOrigin(value: any): void {
		this.crossOrigin = value;
	}
}